// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"bb06148e","180":"5cdf2148","243":"423f562a","260":"f19498c2","331":"923685c4","393":"1eab9611","394":"5e2e0387","453":"172795fa","615":"ecb76d20","809":"595c3d46","818":"131b4cf2","936":"4067e96a"}[chunkId] + ".chunk.js";
};